export default __webpack_public_path__ + "static/media/share-screen-off.b58424db.png";